module.exports = __webpack_public_path__ + "static/media/delivery-bike.72ea5393.svg";